import React, { useContext } from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import formatMetric from "../util/formatMetric";
import ForwardersContext from "../forwarders/ForwardersContext";
const StyledThroughput = styled.dl(
  ({ theme }) => css`
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;

    @media all and (max-width: ${theme.breakpoints.min.lg}) {
      flex-direction: column;
    }

    > dd {
      min-width: 220px;
    }
  `
);
const ForwarderThroughput = ({ forwarderId }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const { getForwarderContext } = useContext(ForwardersContext);
  const { metrics: forwarderMetrics } = getForwarderContext(forwarderId);
  if (!forwarderMetrics || forwarderMetrics.length === 0) {
    return /* @__PURE__ */ React.createElement("div", null, t("common.no_metrics"));
  }
  const {
    rate: { one_minute: oneMinute, five_minute: fiveMinute, fifteen_minute: fifteenMinute }
  } = forwarderMetrics[0];
  return /* @__PURE__ */ React.createElement(StyledThroughput, null, /* @__PURE__ */ React.createElement("dd", null, " ", !Number.isNaN(oneMinute) && t("forwarder_throughput.one_minute", { value: formatMetric(oneMinute) }), " "), /* @__PURE__ */ React.createElement("dd", null, " ", !Number.isNaN(fiveMinute) && t("forwarder_throughput.five_minute", { value: formatMetric(fiveMinute) }), " "), /* @__PURE__ */ React.createElement("dd", null, " ", !Number.isNaN(fifteenMinute) && t("forwarder_throughput.fifteen_minute", { value: formatMetric(fifteenMinute) }), " "));
};
export default ForwarderThroughput;
